<div class="tccp-confirmation-dialog">
    <div *ngIf="message.type && message.type==='disclaimer'">
        <div mat-dialog-title>
            <div class="row">
                <div class="col-md-10">
                    <h3>{{message.title}}</h3>
                </div>
                <div class="col-md-2">
                    <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
                </div>
            </div>
        </div>
        <div mat-dialog-content>
            <div class="row col-md-12">{{message.message}}</div>
        </div>
    </div>

    <div *ngIf="message.type && message.type==='troubleshooting'">
        <div mat-dialog-title>
            <div class="d-flex">
                <div>
                    <h3>{{message.title}}</h3>
                </div>
                <div class="float-right ml-auto">
                    <span class="fa fa-close action-icons" (click)="close()"></span>
                </div>
            </div>
        </div>
        <div mat-dialog-content>
            <div class="row col-md-12" [innerHTML]="message.message"></div>
        </div>
    </div>

    <div *ngIf="!message.type">
        <div mat-dialog-content class="confirm-modal-content">
            <div class="row col-md-12">{{message}}</div>
        </div>

        <div mat-dialog-actions class="confirm-modal-footer">
            <span>
                <button mat-button class="btn btn-default btn-yes" [ngClass]="selectedApp==='toyota' ? 'toyota-division' : 'lexus-division'" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
            </span>
            <span class="ml-2">
                <button mat-button class="btn btn-secondary" (click)="close()">No</button>
            </span>
        </div>
    </div>

    <div *ngIf="message.type && message.type === 'basic'">
        <div mat-dialog-title>
            <div class="row">
                <div class="col-md-10">
                    <h3>{{message.title}}</h3>
                </div>
                <div class="col-md-2">
                    <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
                </div>
            </div>
        </div>
        <div mat-dialog-content class="confirm-modal-content">
            <div class="row col-md-12">{{message.message}}</div>
        </div>
    </div>

    <div *ngIf="message.type && message.type === 'basic-html'">
        <div mat-dialog-title>
            <div class="row">
                <div class="col-md-10">
                    <h3>{{message.title}}</h3>
                </div>
                <div class="col-md-2">
                    <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
                </div>
            </div>
        </div>
        <div mat-dialog-content>
            <div class="row col-md-12" [innerHTML]="message.message"></div>
        </div>
    </div>
</div>